import type { Document } from "#shared/types/document";
import type { UseSeoMetaInput } from "@unhead/vue";

export function useDocumentSeo(
  { seo, cover }: Document,
  extra?: UseSeoMetaInput,
) {
  const ogTitle = withCompanyPrefix(seo?.ogTitle);
  const ogDescription = seo?.ogDescription;
  const ogImage = cover?.url;

  useSeoMeta({
    title: withCompanyPrefix(seo?.title),
    ogTitle,
    description: seo?.description,
    ogDescription,
    ogImage,
    twitterTitle: ogTitle,
    twitterDescription: ogDescription,
    twitterImage: ogImage,
    twitterImageAlt: cover?.altText,
    ...extra,
  });
}
